<template>
  <LabeledIcon
    v-overflow-title="text"
    :icon="icon"
    :label="text"
  />
</template>

<script>
  import appContext from 'legacy/appcontext';
  import LabeledIcon from 'legacy/modules/common/components/LabeledIcon';
  import {getWaIconByChannelId} from 'legacy/modules/webanalytics/providersicons';
  import {nbsp} from 'legacy/utils';

  export default {
    name: 'GoalProfileName',
    components: {LabeledIcon},
    props: {
      profile: {
        type: Object,
        default: null
      },
      goal: {
        type: Object,
        default: null
      },
      providerId: {
        type: Number,
        required: true
      }
    },
    computed: {
      text () {
        if (this.goal && this.profile) {
          const goalText = appContext.tr('Goal');
          const profileText = appContext.trc('genitive', 'profile');
          return `${goalText} ${this.goalName} ${profileText} ${this.profileName}`;
        } else if (this.goal) {
          const goalText = appContext.tr('Goal');
          return `${goalText}${nbsp}${this.goalName}`;
        }
        const profileText = appContext.tr('Profile');
        return `${profileText}${nbsp}${this.profileName}`;
      },
      profileName () {
        return `№${this.profile.xid}${nbsp}${this.profile.name}`;
      },
      goalName () {
        return `№${this.goal.xid}${nbsp}${this.goal.name}`;
      },
      icon () {
        return getWaIconByChannelId(this.providerId);
      }
    }
  };
</script>
